import {
	addFavourite,
	clearAll,
	removeFavourite,
} from '@/services/favouritesService'

import { create } from 'zustand'
import { flushCurrentSession } from '@/services/sessionService'

interface FavouritesState {
	favouriteTracks: number[]
	setFavouriteTracks: (favouriteTracks: number[]) => void
	toggleFavourite: (trackId: number) => void
	clearAllFavourites: () => void
}
const useFavouritesStore = create<FavouritesState>()((set, get) => ({
	favouriteTracks: [],
	setFavouriteTracks: (favouriteTracks) => {
		set({
			favouriteTracks,
		})
	},
	toggleFavourite: (trackId) => {
		flushCurrentSession()
		const isFavourite = get().favouriteTracks.some(
			(favouriteTrackId) => favouriteTrackId === trackId
		)
		if (isFavourite) {
			removeFavourite(trackId).then(() => {
				set((state) => ({
					favouriteTracks: state.favouriteTracks.filter(
						(favouriteTrackId) => favouriteTrackId !== trackId
					),
				}))
			})
		} else {
			addFavourite(trackId).then(() => {
				set((state) => ({
					favouriteTracks: [...state.favouriteTracks, trackId],
				}))
			})
		}
	},
	clearAllFavourites: () => {
		flushCurrentSession()
		clearAll().then(() => {
			set(() => ({
				favouriteTracks: [],
			}))
		})
	},
}))
export default useFavouritesStore
